module.exports = __webpack_public_path__ + "img/lg_ring_skip_0_0_1@3x.6e343747.png";